import React from 'react';
import { personal } from '../data';

export default function Nav() {
  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0,
      height: '56px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '0 2.5rem',
      background: 'rgba(244,243,240,0.82)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      borderBottom: '0.5px solid rgba(100,98,92,0.15)',
      zIndex: 100,
      fontFamily: "'DM Mono', monospace",
    }}>
      <a href="#hero" style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontWeight: 300, fontSize: '18px',
        letterSpacing: '0.04em', fontStyle: 'italic',
        color: '#2e2d2a', textDecoration: 'none',
      }}>
        {personal.namePlain} {personal.nameItalic}
      </a>

      <div style={{ display: 'flex', gap: '2rem' }}>
        {['about', 'education', 'projects', 'contact'].map((s) => (
          <a key={s} href={`#${s}`} style={{
            fontSize: '11px', letterSpacing: '0.12em',
            textTransform: 'uppercase', color: '#6b6963',
            textDecoration: 'none', transition: 'color 0.2s',
          }}
          onMouseEnter={e => e.target.style.color = '#2e2d2a'}
          onMouseLeave={e => e.target.style.color = '#6b6963'}
          >
            {s}
          </a>
        ))}
      </div>
    </nav>
  );
}
